<template>
  <span>{{ $numbers(value).formatCurrency({ mantissa: 2, thousandSeparated: true }) }}</span>
</template>

<script>
export default {
  props: ['value']
}
</script>
